module.exports = __webpack_public_path__ + "static/media/fill-drip.76a821a8.svg";